import { render } from "./CardAccordion.vue?vue&type=template&id=666c6cc0&scoped=true&ts=true"
import script from "./CardAccordion.vue?vue&type=script&lang=ts"
export * from "./CardAccordion.vue?vue&type=script&lang=ts"

import "./CardAccordion.vue?vue&type=style&index=0&id=666c6cc0&scoped=true&lang=css"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666c6cc0"]])

export default __exports__